module.exports = __webpack_public_path__ + "media/assets/svgs/close-0d69e6573aaa62a0d69d711a0d75ebb7.svg";